// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title--accordion[data-v-61d9f536] {\n  font-weight: var(--magic-font-weight-bold, 700);\n  color: #fff;\n  text-transform: none;\n}\n\n.badge[data-v-61d9f536] {\n  --magic-badge-background: rgba(255, 255, 255, 0.1);\n  --magic-error-contrast: #fff;\n}\n\n.promotions[data-v-61d9f536] {\n  --magic-promotions-accordion-toggle-background: #1f2223;\n}", ""]);
// Exports
module.exports = exports;
